export const buttonType = {
  LINK: 'link',
  BUTTON: 'button',
};

export const actions = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};
export const boards = {
  C3_MINI: 'C3-Mini',
  D1_MINI: 'D1-Mini',
  ESP32_MINI: 'ESP32-Mini',
};

export const groups = {
  CLOUDFREE: 'cloudfree',
  IAS: 'ias',
  HA: 'ha',
};
